import api, { apiWithoutBaseURL } from './api'

class AbhsService {
    // 获取单词表列表
    async getWordList(userId) {
        try {
            const response = await api.get(`/userwordsList/getWordList/?id=${userId}`)
            return response.data
        } catch (error) {
            console.error('获取单词表列表失败:', error)
            throw error
        }
    }

    // 获取单词表中的单词
    async getWords(userId, wordsName) {
        try {
            const response = await api.post('/userwordsView/getWords/', {
                userid: userId,
                words: wordsName
            })
            return response.data
        } catch (error) {
            console.error('获取单词失败:', error)
            throw error
        }
    }

    // 修改单词掌握程度
    async changeStrength(userId, fromNodeId, toNodeId, result) {
        try {
            const response = await api.post('/userstrengthchange/changeStrength/', {
                userid: userId,
                fromNodeId: fromNodeId,
                toNodeId: toNodeId,
                result: result
            })
            return response.data
        } catch (error) {
            console.error('修改单词掌握程度失败:', error)
            throw error
        }
    }

    // 获取用户排名
    async getUserRanking() {
        try {
            const response = await api.get('/userranking/getUserRanking/')
            return response.data
        } catch (error) {
            console.error('获取用户排名失败:', error)
            throw error
        }
    }

    // 导入单词表
    async importWords(userId, wordsName, wordsVersion, wordsCategory, wordsType) {
        try {
            // 使用不带 baseURL 的 axios 实例
            const response = await apiWithoutBaseURL.post('/QuickResponse/api/importWords/', {
                userid: userId,
                wordsName: wordsName,
                wordsVersion: wordsVersion,
                wordsCategory: wordsCategory,
                wordsType: wordsType
            })
            return response.data
        } catch (error) {
            console.error('导入单词表失败:', error)
            throw error
        }
    }

    // 获取标准库数据
    async getStandardLibrary() {
        try {
            const response = await api.get('/userstandardlibrary/getStandardLibrary/')
            console.log('API响应原始数据:', response) // 添加调试日志

            // 检查响应结构
            console.log('响应数据类型:', typeof response)
            console.log('响应数据结构:', response)

            // 确保返回正确的数据结构
            // Django REST Framework 返回的数据通常在 response.data 中
            if (response.data && response.data.status === 200) {
                return response.data
            } else {
                // 如果响应结构不同，直接返回整个响应数据
                return {
                    status: 200,
                    data: response.data.data || response.data
                }
            }
        } catch (error) {
            console.error('获取标准库数据失败:', error)
            throw error
        }
    }

    // 测试获取标准库数据
    async testGetStandardLibrary() {
        try {
            console.log('开始测试获取标准库数据...')
            const result = await this.getStandardLibrary()
            console.log('测试结果:', result)

            // 详细分析响应结构
            if (result) {
                console.log('=== 详细响应结构分析 ===')
                console.log('结果类型:', typeof result)
                console.log('结果结构:', Object.keys(result))

                if (result.data) {
                    console.log('数据部分类型:', typeof result.data)
                    console.log('数据部分结构:', Object.keys(result.data))

                    if (result.data.data) {
                        console.log('实际数据类型:', typeof result.data.data)
                        console.log('实际数据结构:', Object.keys(result.data.data))
                    }
                }
            }

            return result
        } catch (error) {
            console.error('测试获取标准库数据失败:', error)
            throw error
        }
    }

    // 添加单词
    async addWord(userId, wordsName, wordName, wordDesc) {
        try {
            // 使用不带 baseURL 的 axios 实例
            const response = await apiWithoutBaseURL.post('/QuickResponse/api/add_node/', {
                userid: userId,
                wordsName: wordsName,
                name: wordName,
                desc: wordDesc
            })
            return response.data
        } catch (error) {
            console.error('添加单词失败:', error)
            throw error
        }
    }

    // 修改单词
    async modifyWord(userId, wordId, wordName, wordDesc) {
        try {
            // 使用不带 baseURL 的 axios 实例
            const response = await apiWithoutBaseURL.post('/QuickResponse/api/modify_node/', {
                userid: userId,
                id: wordId,
                name: wordName,
                desc: wordDesc
            })
            return response.data
        } catch (error) {
            console.error('修改单词失败:', error)
            throw error
        }
    }

    // 删除单词
    async deleteWord(userId, wordsName, wordId) {
        try {
            // 使用不带 baseURL 的 axios 实例
            const response = await apiWithoutBaseURL.post('/QuickResponse/api/delete_node/', {
                userid: userId,
                wordsName: wordsName,
                nodeid: wordId
            })
            return response.data
        } catch (error) {
            console.error('删除单词失败:', error)
            throw error
        }
    }

    // 翻译单词（中英文互译）
    async translateWord(word) {
        try {
            // 使用不带 baseURL 的 axios 实例，因为翻译API在Graph应用中
            const response = await apiWithoutBaseURL.post('/Graph/api/translateWord/', {
                word: word
            })
            return response.data
        } catch (error) {
            console.error('翻译单词失败:', error)
            throw error
        }
    }
}

export default new AbhsService()